/**
 * Which entity tab the start step opens on, per the competition's own setting.
 *
 * Admins set this in Registration Setup (General Settings → Other Settings)
 * because the Teams tab can read as overwhelming for a competition whose
 * members register to divisions — the tab that is right depends on how the
 * competition is actually run, so it cannot be a constant in the client.
 *
 * Stored as an enum rather than a "default to divisions" boolean: a boolean
 * encodes today's default in its `false` case, so a third tab would force a
 * data migration, while an enum only gains a member.
 *
 * Unknown, absent and null all resolve to `'teams'`, which is the behaviour
 * that shipped before this setting existed — so the flow is correct against a
 * backend that does not send the key yet, and against one that later sends a
 * value this build has never heard of.
 */

import type { EntityTab } from './types'

const ENTITY_TABS: readonly EntityTab[] = ['teams', 'divisions']

/** What ships when the competition has expressed no preference. */
export const FALLBACK_ENTITY_TAB: EntityTab = 'teams'

export const resolveDefaultEntityTab = (
  value: string | null | undefined
): EntityTab =>
  ENTITY_TABS.includes(value as EntityTab)
    ? (value as EntityTab)
    : FALLBACK_ENTITY_TAB
